import React from 'react'

export default ({ width, height, colorFill }) => (
  <svg width={width} height={height} viewBox="0 0 512 512">
    <path
      fill={colorFill}
      d="M441.2,259.6v182.9c0,8.5-3,15.7-8.9,21.6c-5.9,5.9-13.1,8.9-21.6,8.9H106c-8.5,0-15.7-3-21.6-8.9
		c-5.9-5.9-8.9-13.1-8.9-21.6V259.6c0-8.5,3-15.7,8.9-21.6c5.9-5.9,13.1-8.9,21.6-8.9h10.2v-61c0-38.9,14-72.4,41.9-100.3
		S219.4,26,258.4,26c38.9,0,72.4,14,100.3,41.9s41.9,61.4,41.9,100.3v61h10.2c8.5,0,15.7,3,21.6,8.9
		C438.3,244,441.2,251.2,441.2,259.6z M177.1,229.2h162.5v-61c0-22.4-7.9-41.6-23.8-57.5s-35-23.8-57.5-23.8
		c-22.4,0-41.6,7.9-57.5,23.8s-23.8,35-23.8,57.5V229.2z"
    />
  </svg>
)
